/**
 * Route-change page-view tracking. Mounted once per authenticated shell
 * (OfficeLayout, TechLayout) — public pages are deliberately untracked.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/services/usage-telemetry.service';

export function usePageTelemetry(): void {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
}
